import { checkToken } from "@/api/lst";
import { getLstToken, getLstPhone } from "@/utils/lstSessionStorage";
import { tokenCheckFresh, setTokenCheckResult, clearTokenCheckCache } from "@/utils/tokenCheckCache";
const inflightByKey = new Map();
const inflightKey = (token, phone) => `${token}${phone || ""}`;
export function recordLstTokenCheckResult(success) {
    const token = getLstToken();
    const phone = getLstPhone();
    if (!token) {
        clearTokenCheckCache();
        return;
    }
    setTokenCheckResult(!!success, token);
}
export async function validateLstToken() {
    const token = getLstToken();
    const phone = getLstPhone();
    if (!token) {
        clearTokenCheckCache();
        return { code: 0, message: "\u672A\u767B\u5F55" };
    }
    if (tokenCheckFresh(token)) {
        return { code: 1 };
    }
    const key = inflightKey(token, phone);
    const existing = inflightByKey.get(key);
    if (existing)
        return existing;
    const checkedToken = token;
    const checkedPhone = phone;
    const p = checkToken(checkedToken, checkedPhone).then((res) => {
        const nowToken = getLstToken();
        const nowPhone = getLstPhone();
        if (nowToken !== checkedToken || nowPhone !== checkedPhone) {
            clearTokenCheckCache();
            return validateLstToken();
        }
        setTokenCheckResult(Number(res?.code) === 1 || res?.success === true, checkedToken);
        return res;
    }).finally(() => {
        inflightByKey.delete(key);
    });
    inflightByKey.set(key, p);
    return p;
}
export { clearTokenCheckCache } from "@/utils/tokenCheckCache";
